import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 600px)
      // and hide it when reaching the offer section
      const scrollY = window.scrollY;
      const offerSection = document.getElementById('compra');
      if (offerSection) {
        const offerTop = offerSection.offsetTop;
        setIsVisible(scrollY > 600 && scrollY < offerTop - 500);
      } else {
        setIsVisible(scrollY > 600);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-165">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-slate-200 shadow-[0_-10px_40px_rgba(0,0,0,0.1)] z-40 md:hidden" data-id="element-166">
          <button onClick={scrollToCompra} className="w-full bg-[#d4a017] hover:bg-[#c29215] text-white font-bold py-3.5 px-6 rounded-xl text-[16px] transition-transform active:scale-95 shadow-lg flex justify-between items-center" data-id="element-167">
            <span data-id="element-168">👉 QUIERO EL KIT</span>
            <span className="bg-white/20 px-2 py-1 rounded text-sm" data-id="element-169">
              $19.900 ARS
            </span>
          </button>
        </motion.div>}
    </AnimatePresence>;
}